import React, { useEffect, useState } from "react";
import api from "../api/api"
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { alphaNumericPattern, emailrgx } from "../assets/constant";
import { titles } from "../assets/titles";

import { useAuth } from "../context/AuthContext";

import { useTranslation } from "react-i18next";
const AddEmployer = (prop) => {
  const {user} = useAuth();
  const { onRefresh } = prop;
  const closeRef = React.useRef();
const { t } = useTranslation();
  const schema = yup.object({
    title: yup
      .string()
      .matches(alphaNumericPattern, "Please enter a valid title")
      .required("Please enter employer title"),
    name: yup
      .string()
      .matches(alphaNumericPattern, "Please enter a valid name")
      .required("Please enter employer name"),
    phone: yup
      .string()//.matches(/^\+\d{1,4}\d{6,14}$/, "Please enter a valid international phone number")
      .required("Contact number is required"),
    email: yup
      .string()
      // .matches(emailrgx, "Email format is required")
      .trim(),
  });

  const {
    reset,
    handleSubmit,
    register,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    //defaultValues: inputValues,
  });

  const [loadingSendInv,setloadingSendInv] = useState(false)
  const [successinvite,setsuccessinvite] = useState(null)

  const onSubmit = async(data) => {
    clearErrors();
    setsuccessinvite(null)
    let typeurl;
    if (user.type == "agency")typeurl="/employer-management/"
    else return

    if (loadingSendInv) return;
    setloadingSendInv(true);
        
    try {
      const response = await api.post(typeurl, data ); 

      console.log("User Data:", response.data);
      console.log("Response Code:", response.status);

      console.log("Form submitted successfully!");
      reset();
      setsuccessinvite(response.data['result'])
      if (onRefresh) onRefresh();
      closeRef.current.click(); 
    } catch (error) {
      let  errorMessage = ""
      // Extract response code if available
      const responseCode = error.response ? error.response.status : "Unknown";
      

      if (error?.response?.data) {
          
        Object.entries(error.response.data).forEach(([key, values]) => {
          //if (key !== "token" && key !== "invite-agency-vendo") {
            
            errorMessage += `${values}\n`;
          //}
        });
      }
      
      // If no specific error was found, provide a default message
      if (!errorMessage) {
        errorMessage = "An unknown error occurred.";
      }
      
      // Set the error message in React Hook Form
      setError("root", { type: "server", message: errorMessage });
    } finally {
        setloadingSendInv(false);
    }
  }
  useEffect(()=>{ 
    clearErrors();
  },[])

  return (
    <div className="modal custom-modal modal-lg fade" id="add_employer" role="dialog">
      <div className="modal-dialog modal-dialog-centered modal-md">
        <div className="modal-content">
          <div className="modal-header border-0 pb-0">
            <div className="form-header modal-header-title text-start mb-0">
              <h4 className="mb-0">{t("Add Employer")}</h4>
            </div>
            <button type="button" className="btn-close" ref={closeRef}data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <form  onSubmit={handleSubmit(onSubmit)}>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-12">
                  <div className="card-body">
                    <div className="form-groups-item">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="input-block mb-3">
                            <label htmlFor="title" className="form-label">{t("Title")}</label>
                            <select
                              className="form-select"
                              id="title"
                              {...register("title")}
                            >
                              <option value="">{t("Select title")}</option>
                              {titles.map((title) => (
                                <option key={title} value={title}>
                                    {title}
                                </option>
                              ))}
                            </select>
                            <p className="text-danger">{errors?.title?.message}</p>
                          </div>
                          <div className="input-block mb-3">
                            <label>{t("Name")}</label>
                            <input type="name"
                              {...register("name")}
                              className="form-control"  />
                            <p className={"text-danger"}>{errors?.name?.message}</p>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="input-block mb-3">
                            <label>{t("Phone")}</label>
                            <input type="phone"
                              {...register("phone")}
                              className="form-control"  />
                            <p className={"text-danger"}>{errors?.phone?.message}</p>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="input-block mb-3">
                            <label>{t("Email")}</label>
                            <input type="email"
                              {...register("email")}
                              className="form-control"  />
                            <p className={"text-danger"}>{errors?.email?.message}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <small  style={{color:"green"}}> {successinvite && <p>{t("Employer Added successfully")}</p>}</small>
              {errors.root && <p style={{color:"red"}}>{errors.root.message}</p>}
              <button type="button" data-bs-dismiss="modal" className="btn btn-back cancel-btn me-2">{t("Cancel")}</button>
              <button type="submit"  className="btn btn-primary ">{t("Add Employer")}
                {loadingSendInv && <i className="fa-solid fa-spinner fa-spin" style={{margin: "0 10px"}}></i> }
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  ); 
};

export default AddEmployer;
